// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "auth/v1/auth.proto" (package "auth.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { InternalAuthService } from "./auth";
import type { GetOAuthLoginClientIDResponse } from "./auth";
import type { GetOAuthLoginClientIDRequest } from "./auth";
import type { SetOAuthLoginClientIDResponse } from "./auth";
import type { SetOAuthLoginClientIDRequest } from "./auth";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { IsKeyDefaultResponse } from "./auth";
import type { IsKeyDefaultRequest } from "./auth";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service auth.v1.InternalAuthService
 */
export interface IInternalAuthServiceClient {
    /**
     * @generated from protobuf rpc: IsKeyDefault(auth.v1.IsKeyDefaultRequest) returns (auth.v1.IsKeyDefaultResponse);
     */
    isKeyDefault(input: IsKeyDefaultRequest, options?: RpcOptions): UnaryCall<IsKeyDefaultRequest, IsKeyDefaultResponse>;
    /**
     * @generated from protobuf rpc: SetOAuthLoginClientID(auth.v1.SetOAuthLoginClientIDRequest) returns (auth.v1.SetOAuthLoginClientIDResponse);
     */
    setOAuthLoginClientID(input: SetOAuthLoginClientIDRequest, options?: RpcOptions): UnaryCall<SetOAuthLoginClientIDRequest, SetOAuthLoginClientIDResponse>;
    /**
     * @generated from protobuf rpc: GetOAuthLoginClientID(auth.v1.GetOAuthLoginClientIDRequest) returns (auth.v1.GetOAuthLoginClientIDResponse);
     */
    getOAuthLoginClientID(input: GetOAuthLoginClientIDRequest, options?: RpcOptions): UnaryCall<GetOAuthLoginClientIDRequest, GetOAuthLoginClientIDResponse>;
}
/**
 * @generated from protobuf service auth.v1.InternalAuthService
 */
export class InternalAuthServiceClient implements IInternalAuthServiceClient, ServiceInfo {
    typeName = InternalAuthService.typeName;
    methods = InternalAuthService.methods;
    options = InternalAuthService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: IsKeyDefault(auth.v1.IsKeyDefaultRequest) returns (auth.v1.IsKeyDefaultResponse);
     */
    isKeyDefault(input: IsKeyDefaultRequest, options?: RpcOptions): UnaryCall<IsKeyDefaultRequest, IsKeyDefaultResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<IsKeyDefaultRequest, IsKeyDefaultResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetOAuthLoginClientID(auth.v1.SetOAuthLoginClientIDRequest) returns (auth.v1.SetOAuthLoginClientIDResponse);
     */
    setOAuthLoginClientID(input: SetOAuthLoginClientIDRequest, options?: RpcOptions): UnaryCall<SetOAuthLoginClientIDRequest, SetOAuthLoginClientIDResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetOAuthLoginClientIDRequest, SetOAuthLoginClientIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetOAuthLoginClientID(auth.v1.GetOAuthLoginClientIDRequest) returns (auth.v1.GetOAuthLoginClientIDResponse);
     */
    getOAuthLoginClientID(input: GetOAuthLoginClientIDRequest, options?: RpcOptions): UnaryCall<GetOAuthLoginClientIDRequest, GetOAuthLoginClientIDResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetOAuthLoginClientIDRequest, GetOAuthLoginClientIDResponse>("unary", this._transport, method, opt, input);
    }
}
